import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { sectors } from "../data/sectors";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { PageHero, CTABand } from "../components/Blocks";
import { IconTile, SECTOR_ICONS } from "../components/Icons";

const head = getHead("/sectors");

export default function SectorsIndex() {
  return (
    <>
      <Seo title={head.title} description={head.description} path="/sectors" />
      <PageHero
        overline="Industries"
        title="Security Programs by Sector"
        lead="Every industry carries its own risk profile, regulations and operating rhythm. Our sector-specific guard programs are built around yours."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="sectors-directory">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {sectors.map((s) => (
            <Link
              key={s.slug}
              to={`/sectors/${s.slug}`}
              data-testid={`sectors-page-card-${s.slug}`}
              className="group relative border border-white/10 rounded-sm overflow-hidden h-60 flex items-end transition-all duration-200 hover:-translate-y-1 hover:border-[#FF5500]/50"
            >
              <IconTile icon={SECTOR_ICONS[s.slug] || Shield} size="h-16 w-16" className="absolute inset-0 h-full" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D0E12] via-[#0D0E12]/60 to-transparent" />
              <div className="relative p-5">
                <h2 className="font-display text-xl font-bold uppercase tracking-tight text-white">{s.name}</h2>
                <p className="mt-1 text-xs text-gray-400 leading-relaxed">{s.blurb}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTABand title="Your Industry, Your Program" sub="Tell dispatch about your sector and site — we'll design a guard program around your actual risk, not a generic template." />
    </>
  );
}
